import { SPORT_SESSION_TYPES } from './sport.session.types.schema';

// OBSEED DS sport palette "Mitte" (Team-Entscheid 07/2026). Hex mirror of the
// --color-sport-* theme tokens in application.tailwind.css — keep the two in sync.
// Feeds Highcharts series colours (profile/research HRV charts, week volume chart).
export const SPORT_SESSION_TYPE_COLORS: Record<string, string> = {
  [SPORT_SESSION_TYPES.SPORT_SESSION_RUN]: '#2e7d4c',
  [SPORT_SESSION_TYPES.SPORT_SESSION_BIKE]: '#c2601f',
  [SPORT_SESSION_TYPES.SPORT_SESSION_SWIM]: '#2a6fa8',
  [SPORT_SESSION_TYPES.SPORT_SESSION_FITNESS]: '#7c5296',
  [SPORT_SESSION_TYPES.SPORT_SESSION_STRENGTH]: '#a83a2b',
  [SPORT_SESSION_TYPES.SPORT_SESSION_YOGA]: '#3b8a7e',
  [SPORT_SESSION_TYPES.SPORT_SESSION_HIKE]: '#80806f',
  [SPORT_SESSION_TYPES.SPORT_SESSION_WALKING]: '#80806f',
  [SPORT_SESSION_TYPES.SPORT_SESSION_OTHER]: '#80806f',
  [SPORT_SESSION_TYPES.SPORT_SESSION_TRANSITION]: '#80806f',
};

export const SPORT_SESSION_TYPE_DEFAULT_COLOR = '#80806f';
